// export function formatDate(date) {
//   if (!(date instanceof Date) || isNaN(date)) return "";

//   let d = date.getDate(); // Day of the month
//   let m = date.getMonth() + 1; // Months are zero-based
//   let y = date.getFullYear(); // Full year

//   // Pad with leading zeros if needed
//   d = d < 10 ? "0" + d : d;
//   m = m < 10 ? "0" + m : m;

//   return `${d}-${m}-${y}`;
// }

export function formatDate(date) {
  if (!date) return ""; // null, undefined, empty → return blank

  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return ""; // invalid date string

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${dd}-${mm}-${yyyy}`;
}

export function formatTime(date) {
  if (!date) return ""; // null, undefined, empty → return blank

  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return ""; // invalid date string

  const timeStr = d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return timeStr;
}

export function formatDateTimeIST(isoString) {
  const date = new Date(isoString);

  // Format in IST using Intl
  const formatted = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);

  // formatted looks like "08/06/2026, 17:46:18"
  // Replace slashes with dashes and remove comma
  return formatted.replace(/\//g, "-").replace(",", "");
}

export function formatDateTime(isoString) {
  const date = new Date(isoString);

  // Convert to local time (browser/system timezone)
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();

  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");

  return `${dd}-${mm}-${yyyy} ${hh}:${min}:${ss}`;
}

// export function toInputDateLocal(date) {
//   if (!(date instanceof Date) || isNaN(date)) return "";
//   const yyyy = date.getFullYear();
//   const mm = String(date.getMonth() + 1).padStart(2, "0");
//   const dd = String(date.getDate()).padStart(2, "0");
//   return `${yyyy}-${mm}-${dd}`; // local yyyy-mm-dd
// }

// export function toInputDate(date, useUTC = false) {
//   if (!date) return "";

//   const d = date instanceof Date ? date : new Date(date);
//   if (isNaN(d)) return "";

//   const yyyy = useUTC ? d.getUTCFullYear() : d.getFullYear();
//   const mm = String((useUTC ? d.getUTCMonth() : d.getMonth()) + 1).padStart(2, "0");
//   const dd = String(useUTC ? d.getUTCDate() : d.getDate()).padStart(2, "0");

//   return `${yyyy}-${mm}-${dd}`;
// }

// Local formatting (default)
// toInputDate(new Date());
// → "2026-06-15" (today in local time)

// UTC formatting (for DOB, consistent across zones)
// toInputDate("2000-01-01T00:00:00Z", true);
// → "2000-01-01"

// Null or invalid
// toInputDate(null);
// → ""

export function toInputDateLocal(date) {
  if (!date) return ""; // null, undefined, empty → return blank

  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return ""; // invalid date string

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function toInputDateIST(date) {
  if (!date) return "";

  const parsedDate = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(parsedDate.getTime())) return "";

  const dateParts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .formatToParts(parsedDate)
    .reduce((parts, part) => {
      if (part.type !== "literal") parts[part.type] = part.value;
      return parts;
    }, {});

  return `${dateParts.year}-${dateParts.month}-${dateParts.day}`;
}

export function getSubscriptionEndDate(startDate, planType) {
  if (!startDate) return "";

  const [year, month, day] = startDate.split("-").map(Number);
  const start = new Date(year, month - 1, day);
  if (Number.isNaN(start.getTime())) return "";

  const durationInMonths = planType === "Annual" ? 12 : 1;
  const targetMonth = start.getMonth() + durationInMonths;
  const lastDayOfTargetMonth = new Date(
    start.getFullYear(),
    targetMonth + 1,
    0,
  ).getDate();
  const end = new Date(
    start.getFullYear(),
    targetMonth,
    Math.min(start.getDate(), lastDayOfTargetMonth),
  );

  return toInputDateLocal(end);
}

export function getIncludedSubscriptionExpiryDate(endDate) {
  if (!endDate) return "";

  const parsedDate = endDate instanceof Date ? endDate : new Date(endDate);
  if (Number.isNaN(parsedDate.getTime())) return "";

  const dateParts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .formatToParts(parsedDate)
    .reduce((parts, part) => {
      if (part.type !== "literal") parts[part.type] = part.value;
      return parts;
    }, {});

  const includedDate = new Date(
    Date.UTC(Number(dateParts.year), Number(dateParts.month) - 1, Number(dateParts.day) - 1),
  );

  return `${includedDate.getUTCFullYear()}-${String(includedDate.getUTCMonth() + 1).padStart(2, "0")}-${String(includedDate.getUTCDate()).padStart(2, "0")}`;
}

export function formatIncludedSubscriptionExpiryDate(endDate) {
  const includedDate = getIncludedSubscriptionExpiryDate(endDate);
  if (!includedDate) return "";

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: "UTC",
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(`${includedDate}T00:00:00.000Z`));
}

export function getSubscriptionExpiryBoundaryIST(endDate) {
  if (!endDate) return null;

  const parsedDate = endDate instanceof Date ? endDate : new Date(endDate);
  if (Number.isNaN(parsedDate.getTime())) return null;

  const dateParts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .formatToParts(parsedDate)
    .reduce((parts, part) => {
      if (part.type !== "literal") parts[part.type] = Number(part.value);
      return parts;
    }, {});

  return new Date(
    Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day) - 330 * 60 * 1000,
  );
}

// Convert Roman numeral string → integer
function romanToInt(roman) {
  const map = { I: 1, V: 5, X: 10, L: 50, C: 100, D: 500, M: 1000 };
  let result = 0;

  for (let i = 0; i < roman.length; i++) {
    const curr = map[roman[i]];
    const next = map[roman[i + 1]];

    if (next && curr < next) {
      result -= curr; // subtract if smaller before larger (e.g., IV = 4)
    } else {
      result += curr;
    }
  }
  return result;
}

// Detect if grade is Roman numeral or plain number
function parseGrade(grade) {
  if (/^[IVXLCDM]+$/.test(grade)) {
    return romanToInt(grade); // Roman numeral
  }
  return Number(grade); // Plain number
}

// Utility sort function
export function sortClasses(classes) {
  return classes.sort((a, b) => {
    const gradeA = parseGrade(a.grade);
    const gradeB = parseGrade(b.grade);

    if (gradeA < gradeB) return -1;
    if (gradeA > gradeB) return 1;

    // If grade same → sort by section
    if (a.section < b.section) return -1;
    if (a.section > b.section) return 1;
    return 0;
  });
}

export function toProperCase(str) {
  if (typeof str !== "string") return str;

  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const formatCurrency = (value) => {
  const number = Number(value) || 0;
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(number);
};

// export const formatNumber = (value) => {
//   if (value >= 1_000_000_000) {
//     return (value / 1_000_000_000).toFixed(1) + "B";
//   } else if (value >= 1_000_000) {
//     return (value / 1_000_000).toFixed(1) + "M";
//   } else if (value >= 1_000) {
//     return (value / 1_000).toFixed(1) + "K";
//   }
//   return value;
// };

// Create a formatter with compact notation
export const formatNumber = (value, locale = "en-IN") => {
  return new Intl.NumberFormat(locale, {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1,
  }).format(value);
};

// export const formatNumber = (value) => {
//   const userLocale = navigator.language || "en-IN"; // fallback
//   return new Intl.NumberFormat(userLocale, {
//     notation: "compact",
//     compactDisplay: "short",
//     maximumFractionDigits: 1,
//   }).format(value);
// };

export const formatCurrencyValue = (
  value,
  locale = "en-IN",
  currencySymbol = "₹",
) => {
  return (
    currencySymbol +
    new Intl.NumberFormat(locale, {
      notation: "compact",
      compactDisplay: "short",
      maximumFractionDigits: 1,
    }).format(value)
  );
};

// export const formatCurrencyValue = (value) => {
//   const userLocale = navigator.language || "en-IN"; // fallback

//   const currencyMap = {
//     "en-US": "$",
//     "en-IN": "₹",
//     "en-GB": "£",
//     "fr-FR": "€",
//   };
//   const currencySymbol = currencyMap[userLocale] || "₹";

//   return (
//     currencySymbol +
//     new Intl.NumberFormat(userLocale, {
//       notation: "compact",
//       compactDisplay: "short",
//       maximumFractionDigits: 1,
//     }).format(value)
//   );
// };

export const formatExactCurrency = (value) =>
  `₹${new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0)}`;
